/**
 * @generated SignedSource<<e571a38e7596611b3938bd1309fd3e58>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TrackViewEvent = "DIRECT" | "INDIRECT" | "SKIP";
export type GoalHeaderRefreshedQuery$variables = {
  isNavRefreshEnabled: boolean;
  key: string;
  trackViewEvent?: TrackViewEvent | null;
};
export type GoalHeaderRefreshedQuery$data = {
  readonly goal?: {
    readonly " $fragmentSpreads": FragmentRefs<"GoalHeaderBreadcrumbs" | "GoalMetaActions" | "GoalTabsRefreshed" | "GoalTitle" | "PlatformGoalIcon">;
  } | null;
};
export type GoalHeaderRefreshedQuery = {
  response: GoalHeaderRefreshedQuery$data;
  variables: GoalHeaderRefreshedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isNavRefreshEnabled"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "trackViewEvent"
},
v3 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "key"
  },
  {
    "kind": "Variable",
    "name": "trackViewEvent",
    "variableName": "trackViewEvent"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "name"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "key"
},
v7 = {
  "concreteType": "GoalIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "ScalarField",
      "name": "appearance"
    }
  ]
},
v8 = {
  "kind": "ScalarField",
  "name": "value"
},
v9 = {
  "kind": "ScalarField",
  "name": "score"
},
v10 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v11 = {
  "kind": "ScalarField",
  "name": "watching"
},
v12 = {
  "kind": "ScalarField",
  "name": "archived"
},
v13 = {
  "concreteType": "Goal",
  "kind": "LinkedField",
  "name": "parentGoal",
  "plural": false,
  "selections": [
    (v5/*: any*/)
  ]
},
v14 = {
  "args": [
    {
      "kind": "Literal",
      "name": "includeScore",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "label",
  "storageKey": "label(includeScore:false)"
},
v15 = [
  {
    "kind": "ScalarField",
    "name": "messageId"
  }
],
v16 = {
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": (v15/*: any*/)
},
v17 = {
  "alias": "goalStateValue",
  "kind": "ScalarField",
  "name": "value"
},
v18 = {
  "concreteType": "CompletionGoalState",
  "kind": "LinkedField",
  "name": "atCompletionState",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    (v16/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/)
  ]
},
v19 = [
  (v14/*: any*/),
  (v16/*: any*/),
  (v9/*: any*/),
  (v17/*: any*/),
  (v18/*: any*/)
],
v20 = {
  "kind": "ScalarField",
  "name": "label"
},
v21 = [
  {
    "kind": "Literal",
    "name": "longFormat",
    "value": true
  }
],
v22 = [
  {
    "kind": "ScalarField",
    "name": "confidence"
  },
  (v20/*: any*/),
  (v16/*: any*/),
  {
    "alias": "tooltip",
    "args": (v21/*: any*/),
    "kind": "ScalarField",
    "name": "label",
    "storageKey": "label(longFormat:true)"
  },
  {
    "alias": "localizedTooltip",
    "args": (v21/*: any*/),
    "concreteType": "LocalizationField",
    "kind": "LinkedField",
    "name": "localizedLabel",
    "plural": false,
    "selections": (v15/*: any*/),
    "storageKey": "localizedLabel(longFormat:true)"
  },
  {
    "kind": "ScalarField",
    "name": "overdue"
  }
],
v23 = {
  "concreteType": "TargetDate",
  "kind": "LinkedField",
  "name": "dueDate",
  "plural": false,
  "selections": (v22/*: any*/)
},
v24 = {
  "kind": "ScalarField",
  "name": "aaid"
},
v25 = {
  "kind": "ScalarField",
  "name": "picture"
},
v26 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v27 = {
  "concreteType": "UserPII",
  "kind": "LinkedField",
  "name": "pii",
  "plural": false,
  "selections": [
    (v25/*: any*/),
    (v26/*: any*/)
  ]
},
v28 = {
  "kind": "ScalarField",
  "name": "type"
},
v29 = [
  (v28/*: any*/),
  {
    "kind": "ScalarField",
    "name": "percentage"
  }
],
v30 = {
  "concreteType": "GoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": (v29/*: any*/)
},
v31 = [
  (v8/*: any*/),
  (v5/*: any*/)
],
v32 = {
  "concreteType": "MetricValue",
  "kind": "LinkedField",
  "name": "snapshotValue",
  "plural": false,
  "selections": (v31/*: any*/)
},
v33 = {
  "kind": "ScalarField",
  "name": "startValue"
},
v34 = {
  "kind": "ScalarField",
  "name": "targetValue"
},
v35 = {
  "kind": "ScalarField",
  "name": "subType"
},
v36 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 200
  },
  {
    "kind": "Literal",
    "name": "tql",
    "value": "archived = false"
  }
],
v37 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v38 = {
  "concreteType": "ProjectEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "concreteType": "Project",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        {
          "concreteType": "ProjectPhaseDetails",
          "kind": "LinkedField",
          "name": "newPhase",
          "plural": false,
          "selections": [
            {
              "alias": "_id",
              "kind": "ScalarField",
              "name": "id"
            }
          ]
        },
        {
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "owner",
          "plural": false,
          "selections": [
            (v5/*: any*/),
            (v24/*: any*/),
            (v27/*: any*/)
          ]
        },
        (v6/*: any*/),
        (v4/*: any*/),
        (v10/*: any*/),
        {
          "kind": "ScalarField",
          "name": "private"
        },
        {
          "concreteType": "IconURIs",
          "kind": "LinkedField",
          "name": "iconUrl",
          "plural": false,
          "selections": [
            {
              "concreteType": "ThemeURIs",
              "kind": "LinkedField",
              "name": "square",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "light"
                },
                {
                  "kind": "ScalarField",
                  "name": "dark"
                },
                {
                  "kind": "ScalarField",
                  "name": "transparent"
                }
              ]
            }
          ]
        },
        (v23/*: any*/),
        {
          "concreteType": "ProjectState",
          "kind": "LinkedField",
          "name": "state",
          "plural": false,
          "selections": [
            (v20/*: any*/),
            (v16/*: any*/),
            {
              "alias": "projectStateValue",
              "kind": "ScalarField",
              "name": "value"
            },
            {
              "concreteType": "CompletionProjectState",
              "kind": "LinkedField",
              "name": "atCompletionState",
              "plural": false,
              "selections": [
                (v8/*: any*/),
                (v20/*: any*/),
                (v16/*: any*/)
              ]
            },
            (v8/*: any*/)
          ]
        },
        (v12/*: any*/),
        {
          "concreteType": "UserConnection",
          "kind": "LinkedField",
          "name": "members",
          "plural": false,
          "selections": [
            {
              "concreteType": "UserEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "User",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v24/*: any*/),
                    (v5/*: any*/)
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    (v37/*: any*/)
  ]
},
v39 = {
  "kind": "ScalarField",
  "name": "count"
},
v40 = {
  "concreteType": "WorkspaceAIConfig",
  "kind": "LinkedField",
  "name": "aiConfig",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "enabled"
    }
  ]
},
v41 = {
  "concreteType": "Metric",
  "kind": "LinkedField",
  "name": "metric",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v4/*: any*/),
    (v28/*: any*/),
    (v35/*: any*/),
    (v12/*: any*/)
  ]
},
v42 = {
  "kind": "ScalarField",
  "name": "ari"
},
v43 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v44 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v45 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v46 = {
  "concreteType": "CommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "CommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "Comment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v5/*: any*/),
            (v43/*: any*/),
            (v42/*: any*/),
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v44/*: any*/),
            {
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v24/*: any*/),
                {
                  "concreteType": "UserPII",
                  "kind": "LinkedField",
                  "name": "pii",
                  "plural": false,
                  "selections": [
                    (v25/*: any*/),
                    (v4/*: any*/),
                    (v45/*: any*/),
                    (v26/*: any*/)
                  ]
                },
                (v5/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    (v37/*: any*/)
  ]
},
v47 = [
  (v4/*: any*/)
],
v48 = {
  "kind": "ScalarField",
  "name": "latestUpdateDate"
},
v49 = [
  (v39/*: any*/)
],
v50 = {
  "kind": "ScalarField",
  "name": "summary"
},
v51 = {
  "kind": "ScalarField",
  "name": "title"
},
v52 = {
  "concreteType": "UpdateNote",
  "kind": "LinkedField",
  "name": "notes",
  "plural": true,
  "selections": [
    (v51/*: any*/),
    (v50/*: any*/),
    (v5/*: any*/)
  ]
},
v53 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v54 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v55 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GoalHeaderRefreshedQuery",
    "selections": [
      {
        "condition": "isNavRefreshEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "goal",
            "args": (v3/*: any*/),
            "concreteType": "Goal",
            "kind": "LinkedField",
            "name": "goalByKey",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "GoalTitle"
              },
              {
                "kind": "FragmentSpread",
                "name": "GoalHeaderBreadcrumbs"
              },
              {
                "kind": "FragmentSpread",
                "name": "PlatformGoalIcon"
              },
              {
                "kind": "FragmentSpread",
                "name": "GoalMetaActions"
              },
              {
                "kind": "FragmentSpread",
                "name": "GoalTabsRefreshed"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "GoalHeaderRefreshedQuery",
    "selections": [
      {
        "condition": "isNavRefreshEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "goal",
            "args": (v3/*: any*/),
            "concreteType": "Goal",
            "kind": "LinkedField",
            "name": "goalByKey",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "concreteType": "GoalConnection",
                "kind": "LinkedField",
                "name": "parentGoals",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GoalEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Goal",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v4/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v7/*: any*/),
              (v6/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canPostUpdate"
              },
              {
                "concreteType": "GoalState",
                "kind": "LinkedField",
                "name": "state",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "targetDate"
              },
              {
                "kind": "ScalarField",
                "name": "targetDateConfidence"
              },
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              {
                "concreteType": "GoalConnection",
                "kind": "LinkedField",
                "name": "subGoals",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GoalEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Goal",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          (v5/*: any*/),
                          (v10/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v4/*: any*/),
                          {
                            "concreteType": "GoalState",
                            "kind": "LinkedField",
                            "name": "state",
                            "plural": false,
                            "selections": (v19/*: any*/)
                          },
                          (v23/*: any*/),
                          {
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": [
                              (v24/*: any*/),
                              (v27/*: any*/),
                              (v5/*: any*/)
                            ]
                          },
                          (v30/*: any*/),
                          {
                            "concreteType": "MetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "MetricTargetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "MetricTarget",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v32/*: any*/),
                                      (v33/*: any*/),
                                      (v34/*: any*/),
                                      {
                                        "concreteType": "Metric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": [
                                          (v28/*: any*/),
                                          (v35/*: any*/),
                                          (v5/*: any*/),
                                          (v12/*: any*/)
                                        ]
                                      },
                                      (v5/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "args": (v36/*: any*/),
                            "concreteType": "ProjectConnection",
                            "kind": "LinkedField",
                            "name": "projects",
                            "plural": false,
                            "selections": [
                              (v38/*: any*/),
                              (v37/*: any*/)
                            ],
                            "storageKey": "projects(first:200,tql:\"archived = false\")"
                          }
                        ]
                      }
                    ]
                  },
                  (v39/*: any*/),
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": "connectionId",
                        "kind": "ScalarField",
                        "name": "__id"
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "userUpdateCount"
              },
              {
                "kind": "ScalarField",
                "name": "canEditUpdate"
              },
              {
                "kind": "ScalarField",
                "name": "learningsCount"
              },
              {
                "kind": "ScalarField",
                "name": "risksCount"
              },
              {
                "kind": "ScalarField",
                "name": "decisionsCount"
              },
              {
                "kind": "ScalarField",
                "name": "description"
              },
              {
                "concreteType": "Workspace",
                "kind": "LinkedField",
                "name": "workspace",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  (v5/*: any*/),
                  (v40/*: any*/),
                  {
                    "concreteType": "UserCapabilities",
                    "kind": "LinkedField",
                    "name": "currentUserAppCapabilities",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "Capability",
                        "kind": "LinkedField",
                        "name": "capabilities",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "capability"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "capabilityContainer"
                          },
                          (v5/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v30/*: any*/),
              {
                "concreteType": "MetricTargetConnection",
                "kind": "LinkedField",
                "name": "metricTargets",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "MetricTargetEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "MetricTarget",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v33/*: any*/),
                          (v34/*: any*/),
                          (v32/*: any*/),
                          (v41/*: any*/),
                          (v5/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v42/*: any*/),
              (v46/*: any*/),
              {
                "concreteType": "GoalPhaseDetails",
                "kind": "LinkedField",
                "name": "phase",
                "plural": false,
                "selections": (v47/*: any*/)
              },
              (v48/*: any*/),
              {
                "concreteType": "UserConnection",
                "kind": "LinkedField",
                "name": "watchers",
                "plural": false,
                "selections": (v49/*: any*/)
              },
              {
                "concreteType": "GoalUpdate",
                "kind": "LinkedField",
                "name": "latestUserUpdate",
                "plural": false,
                "selections": [
                  (v43/*: any*/),
                  (v44/*: any*/),
                  (v50/*: any*/),
                  (v52/*: any*/),
                  (v5/*: any*/)
                ]
              },
              {
                "alias": "latestUpdates",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  }
                ],
                "concreteType": "GoalUpdateConnection",
                "kind": "LinkedField",
                "name": "updates",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GoalUpdateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "GoalUpdate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v44/*: any*/),
                          (v53/*: any*/),
                          (v54/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "updates(first:1)"
              },
              {
                "concreteType": "DraftUpdate",
                "kind": "LinkedField",
                "name": "draftUpdate",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "input"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "modifiedDate"
                  },
                  {
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "UserPII",
                        "kind": "LinkedField",
                        "name": "pii",
                        "plural": false,
                        "selections": [
                          (v26/*: any*/),
                          (v4/*: any*/),
                          (v25/*: any*/)
                        ]
                      },
                      (v5/*: any*/)
                    ]
                  },
                  (v5/*: any*/),
                  (v37/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "updateStreak"
              },
              {
                "args": (v55/*: any*/),
                "concreteType": "GoalUpdateConnection",
                "kind": "LinkedField",
                "name": "updates",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GoalUpdateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "GoalUpdate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v44/*: any*/),
                          (v5/*: any*/),
                          {
                            "concreteType": "Goal",
                            "kind": "LinkedField",
                            "name": "goal",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v42/*: any*/),
                              (v10/*: any*/),
                              {
                                "concreteType": "Workspace",
                                "kind": "LinkedField",
                                "name": "workspace",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v5/*: any*/),
                                  (v40/*: any*/)
                                ]
                              },
                              (v11/*: any*/),
                              (v13/*: any*/),
                              (v6/*: any*/),
                              (v4/*: any*/),
                              (v7/*: any*/),
                              {
                                "concreteType": "GoalUpdate",
                                "kind": "LinkedField",
                                "name": "latestUserUpdate",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v44/*: any*/),
                                  (v43/*: any*/),
                                  (v50/*: any*/),
                                  (v52/*: any*/)
                                ]
                              },
                              (v48/*: any*/),
                              {
                                "concreteType": "GoalConnection",
                                "kind": "LinkedField",
                                "name": "subGoals",
                                "plural": false,
                                "selections": (v49/*: any*/)
                              },
                              {
                                "concreteType": "MetricTargetConnection",
                                "kind": "LinkedField",
                                "name": "metricTargets",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "MetricTargetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "MetricTarget",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v33/*: any*/),
                                          (v34/*: any*/),
                                          (v5/*: any*/),
                                          {
                                            "concreteType": "Metric",
                                            "kind": "LinkedField",
                                            "name": "metric",
                                            "plural": false,
                                            "selections": [
                                              (v5/*: any*/),
                                              (v12/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "creator",
                            "plural": false,
                            "selections": [
                              (v24/*: any*/),
                              (v5/*: any*/),
                              {
                                "concreteType": "UserPII",
                                "kind": "LinkedField",
                                "name": "pii",
                                "plural": false,
                                "selections": [
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v4/*: any*/),
                                  (v45/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v53/*: any*/),
                          (v54/*: any*/),
                          {
                            "concreteType": "GoalState",
                            "kind": "LinkedField",
                            "name": "newState",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v9/*: any*/),
                              (v17/*: any*/),
                              (v14/*: any*/),
                              (v16/*: any*/),
                              (v18/*: any*/)
                            ]
                          },
                          (v42/*: any*/),
                          {
                            "concreteType": "GoalMetricUpdateConnection",
                            "kind": "LinkedField",
                            "name": "metricUpdate",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "GoalMetricUpdateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "GoalMetricUpdate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "newStartValue"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "newTargetValue"
                                      },
                                      {
                                        "concreteType": "MetricValue",
                                        "kind": "LinkedField",
                                        "name": "newValue",
                                        "plural": false,
                                        "selections": (v31/*: any*/)
                                      },
                                      (v41/*: any*/),
                                      {
                                        "concreteType": "MetricValue",
                                        "kind": "LinkedField",
                                        "name": "oldValue",
                                        "plural": false,
                                        "selections": (v31/*: any*/)
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "concreteType": "GoalProgress",
                            "kind": "LinkedField",
                            "name": "newProgress",
                            "plural": false,
                            "selections": (v29/*: any*/)
                          },
                          (v46/*: any*/),
                          {
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "lastEditedBy",
                            "plural": false,
                            "selections": [
                              (v24/*: any*/),
                              {
                                "concreteType": "UserPII",
                                "kind": "LinkedField",
                                "name": "pii",
                                "plural": false,
                                "selections": (v47/*: any*/)
                              },
                              (v5/*: any*/)
                            ]
                          },
                          (v43/*: any*/),
                          {
                            "concreteType": "TargetDate",
                            "kind": "LinkedField",
                            "name": "newDueDate",
                            "plural": false,
                            "selections": (v22/*: any*/)
                          },
                          (v50/*: any*/),
                          {
                            "concreteType": "UpdateNote",
                            "kind": "LinkedField",
                            "name": "notes",
                            "plural": true,
                            "selections": [
                              (v12/*: any*/),
                              (v10/*: any*/),
                              (v51/*: any*/),
                              (v50/*: any*/),
                              (v5/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TargetDate",
                            "kind": "LinkedField",
                            "name": "oldDueDate",
                            "plural": false,
                            "selections": (v22/*: any*/)
                          },
                          {
                            "concreteType": "GoalState",
                            "kind": "LinkedField",
                            "name": "oldState",
                            "plural": false,
                            "selections": (v19/*: any*/)
                          },
                          {
                            "concreteType": "GoalPhaseDetails",
                            "kind": "LinkedField",
                            "name": "newPhase",
                            "plural": false,
                            "selections": (v47/*: any*/)
                          },
                          {
                            "kind": "ScalarField",
                            "name": "newTargetDate"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "newTargetDateConfidence"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "__typename"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "Project",
                                    "kind": "LinkedField",
                                    "name": "project",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v5/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "ProjectUpdate"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "url"
                                  }
                                ],
                                "type": "GoalUpdate"
                              }
                            ],
                            "type": "Update",
                            "abstractKey": "__isUpdate"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ],
                "storageKey": "updates(first:10)"
              },
              {
                "args": (v55/*: any*/),
                "handle": "connection",
                "key": "UpdatesList__updates",
                "kind": "LinkedHandle",
                "name": "updates"
              },
              {
                "args": (v36/*: any*/),
                "concreteType": "ProjectConnection",
                "kind": "LinkedField",
                "name": "projects",
                "plural": false,
                "selections": [
                  (v39/*: any*/),
                  (v38/*: any*/),
                  (v37/*: any*/)
                ],
                "storageKey": "projects(first:200,tql:\"archived = false\")"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "f1d39052599d8c5eab81e88f51a695c1",
    "id": null,
    "metadata": {},
    "name": "GoalHeaderRefreshedQuery",
    "operationKind": "query",
    "text": "query GoalHeaderRefreshedQuery(\n  $key: String!\n  $trackViewEvent: TrackViewEvent\n  $isNavRefreshEnabled: Boolean!\n) {\n  goal: goalByKey(key: $key, trackViewEvent: $trackViewEvent) @include(if: $isNavRefreshEnabled) {\n    ...GoalTitle\n    ...GoalHeaderBreadcrumbs\n    ...PlatformGoalIcon\n    ...GoalMetaActions\n    ...GoalTabsRefreshed\n    id\n  }\n}\n\nfragment AddToMissedUpdateMessage on Goal {\n  id\n  latestUpdates: updates(first: 1) {\n    edges {\n      node {\n        id\n        creationDate\n        missedUpdate\n        updateType\n      }\n    }\n  }\n}\n\nfragment Comment on Comment {\n  id\n  ari\n  commentText\n  creationDate\n  editDate\n  creator {\n    aaid\n    ...UserAvatar\n    id\n  }\n}\n\nfragment Comments on CommentConnection {\n  edges {\n    node {\n      id\n      editDate\n      ...Comment\n    }\n  }\n}\n\nfragment CompactGoalSummaryPanel on Goal {\n  ...GoalName\n  state {\n    ...GoalState\n  }\n  ...progressBarMetricTarget\n  ...progressText\n  ...hasMetric\n}\n\nfragment ContributingProjectsSummary on ProjectConnection {\n  edges {\n    node {\n      archived\n      owner {\n        aaid\n        id\n      }\n      members {\n        edges {\n          node {\n            aaid\n            id\n          }\n        }\n      }\n      state {\n        value\n      }\n      id\n    }\n  }\n}\n\nfragment DraftGoalUpdate on DraftUpdate {\n  input\n  modifiedDate\n  author {\n    pii {\n      accountId\n      name\n      picture\n    }\n    id\n  }\n}\n\nfragment DueDateContext on Goal {\n  phase {\n    name\n  }\n  latestUpdateDate\n}\n\nfragment EditGoalProgressEditor on GoalUpdate {\n  metricUpdate {\n    edges {\n      node {\n        metric {\n          id\n          name\n          type\n          subType\n          archived\n        }\n        newValue {\n          value\n          id\n        }\n        newStartValue\n        newTargetValue\n      }\n    }\n  }\n}\n\nfragment EditGoalUpdate on GoalUpdate {\n  id\n  uuid\n  summary\n  newPhase {\n    name\n  }\n  newState {\n    score\n    value\n  }\n  newTargetDate\n  newTargetDateConfidence\n  notes {\n    summary\n    uuid\n    id\n  }\n  goal {\n    id\n    key\n    uuid\n    workspace {\n      uuid\n      id\n      aiConfig {\n        enabled\n      }\n    }\n    latestUserUpdate {\n      editDate\n      creationDate\n      summary\n      notes {\n        title\n        summary\n        id\n      }\n      id\n    }\n    metricTargets {\n      edges {\n        node {\n          metric {\n            id\n            archived\n          }\n          id\n        }\n      }\n    }\n  }\n  ...EditGoalProgressEditor\n}\n\nfragment EditableGoalUpdateCard on GoalUpdate {\n  id\n  goal {\n    id\n  }\n  creationDate\n  creator {\n    aaid\n    id\n  }\n  missedUpdate\n  updateType\n  ...GoalUpdateCard\n  ...EditGoalUpdate\n}\n\nfragment EmptyStateNoUpdates on Goal {\n  watching\n  canPostUpdate\n}\n\nfragment GoalAboutTab on Goal {\n  id\n  description\n  ...GoalDescription\n  ...GoalProgressChart\n  ...GoalComments\n}\n\nfragment GoalActions on Goal {\n  id\n  name\n  archived\n  parentGoal {\n    id\n  }\n  subGoals {\n    edges {\n      node {\n        archived\n        id\n      }\n    }\n  }\n}\n\nfragment GoalComments on Goal {\n  id\n  ari\n  uuid\n  workspace {\n    uuid\n    id\n  }\n  comments {\n    edges {\n      node {\n        id\n      }\n    }\n    ...Comments\n  }\n}\n\nfragment GoalDateChanged on GoalUpdate {\n  oldDueDate {\n    ...TargetDate\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment GoalDatePicker on Goal {\n  id\n  canPostUpdate\n  state {\n    value\n  }\n  targetDate\n  targetDateConfidence\n}\n\nfragment GoalDescription on Goal {\n  id\n  uuid\n  description\n  canPostUpdate\n  workspace {\n    uuid\n    id\n  }\n}\n\nfragment GoalFollowButton on Goal {\n  id\n  uuid\n  watching\n}\n\nfragment GoalHeaderBreadcrumbs on Goal {\n  parentGoals {\n    edges {\n      node {\n        id\n        key\n        name\n      }\n    }\n  }\n}\n\nfragment GoalMetaActions on Goal {\n  key\n  ...GoalStateAndTargetDate\n  ...GoalFollowButton\n  ...GoalActions\n}\n\nfragment GoalMissedUpdateLabel on GoalUpdate {\n  creationDate\n  missedUpdate\n  updateType\n  goal {\n    id\n    key\n    latestUserUpdate {\n      id\n      creationDate\n    }\n    latestUpdateDate\n  }\n}\n\nfragment GoalName on Goal {\n  uuid\n  id\n  key\n  ...PlatformGoalIcon\n  name\n}\n\nfragment GoalProgressChanged on GoalUpdate {\n  metricUpdate {\n    edges {\n      node {\n        metric {\n          type\n          subType\n          archived\n          id\n        }\n        newStartValue\n        newValue {\n          value\n          id\n        }\n        oldValue {\n          value\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment GoalProgressChart on Goal {\n  progress {\n    type\n  }\n  ...MetricChart\n}\n\nfragment GoalProgressEditor on Goal {\n  id\n  progress {\n    percentage\n    type\n  }\n  subGoals {\n    count\n  }\n  metricTargets {\n    edges {\n      node {\n        id\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        targetValue\n        metric {\n          id\n          name\n          type\n          subType\n          archived\n        }\n      }\n    }\n  }\n}\n\nfragment GoalProjects on Goal {\n  id\n  archived\n  projects(tql: \"archived = false\", first: 200) {\n    edges {\n      node {\n        id\n      }\n    }\n    ...ProjectTable\n    ...ContributingProjectsSummary\n  }\n  ...LinkGoalProject\n}\n\nfragment GoalProjectsTab on Goal {\n  projects(tql: \"archived = false\", first: 200) {\n    count\n  }\n  subGoals {\n    count\n  }\n  ...GoalProjects\n  ...GoalSubGoals\n}\n\nfragment GoalState on GoalState {\n  label(includeScore: false)\n  localizedLabel {\n    messageId\n  }\n  score\n  goalStateValue: value\n  atCompletionState {\n    label(includeScore: false)\n    localizedLabel {\n      messageId\n    }\n    value\n    score\n  }\n}\n\nfragment GoalStateAndTargetDate on Goal {\n  canPostUpdate\n  state {\n    value\n    score\n  }\n  ...GoalDatePicker\n}\n\nfragment GoalStatusChanged on GoalUpdate {\n  newState {\n    ...GoalState\n  }\n  oldState {\n    ...GoalState\n  }\n}\n\nfragment GoalSubGoals on Goal {\n  id\n  ari\n  subGoals {\n    edges {\n      node {\n        id\n        archived\n        ...GoalSummaryPanel\n        ...CompactGoalSummaryPanel\n        ...GoalProjects\n      }\n    }\n  }\n}\n\nfragment GoalSummaryPanel on Goal {\n  ...GoalName\n  state {\n    ...GoalState\n  }\n  dueDate {\n    ...TargetDate\n  }\n  owner {\n    ...UserAvatar_2aqwkz\n    id\n  }\n  ...progressBarMetricTarget\n  ...progressText\n  ...hasMetric\n}\n\nfragment GoalTabsRefreshed on Goal {\n  key\n  watching\n  userUpdateCount\n  canEditUpdate\n  learningsCount\n  risksCount\n  decisionsCount\n  ...GoalAboutTab\n  ...GoalUpdatesTab\n  ...GoalProjectsTab\n  ...useUserHasCapabilitiesFromGoal\n}\n\nfragment GoalTitle on Goal {\n  name\n  id\n}\n\nfragment GoalUpdateCard on GoalUpdate {\n  id\n  uuid\n  creator {\n    aaid\n    id\n  }\n  missedUpdate\n  updateType\n  ...MissedGoalUpdateCard\n  ...GoalUpdateCardInternal\n  goal {\n    uuid\n    id\n  }\n}\n\nfragment GoalUpdateCardFooter on GoalUpdate {\n  id\n  ari\n  updateType\n  missedUpdate\n  goal {\n    ari\n    ...GoalFollowButton\n    id\n  }\n  ...ShareUpdateButton\n}\n\nfragment GoalUpdateCardHeader on GoalUpdate {\n  id\n  newState {\n    value\n    score\n  }\n  goal {\n    ...GoalFollowButton\n    parentGoal {\n      id\n    }\n    key\n    name\n    ...PlatformGoalIcon\n    id\n  }\n}\n\nfragment GoalUpdateCardInternal on GoalUpdate {\n  id\n  uuid\n  goal {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...GoalUpdateCardHeader\n  ...GoalUpdateCardTop\n  ...GoalUpdateSummary\n  notes {\n    ...UpdateNote\n    id\n  }\n  ...GoalUpdateDiff\n  ...GoalUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment GoalUpdateCardProgress on GoalUpdate {\n  metricUpdate {\n    edges {\n      node {\n        newStartValue\n        newTargetValue\n        newValue {\n          value\n          id\n        }\n        metric {\n          id\n          name\n          type\n          subType\n          archived\n        }\n      }\n    }\n  }\n  newProgress {\n    type\n    percentage\n  }\n  goal {\n    id\n    subGoals {\n      count\n    }\n    metricTargets {\n      edges {\n        node {\n          startValue\n          targetValue\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment GoalUpdateCardTop on GoalUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...GoalUpdateCreationDate\n  ...GoalUpdateStatus\n  ...GoalMissedUpdateLabel\n  ...GoalUpdateCardProgress\n}\n\nfragment GoalUpdateCardTop_PTxnb on GoalUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...GoalMissedUpdateLabel\n  missedUpdate\n  ...GoalUpdateCardProgress\n}\n\nfragment GoalUpdateComposer on Goal {\n  ...DueDateContext\n  ...NewGoalUpdate\n  ...AddToMissedUpdateMessage\n  draftUpdate {\n    ...DraftGoalUpdate\n    id\n  }\n  id\n  uuid\n  workspace {\n    uuid\n    id\n  }\n}\n\nfragment GoalUpdateCreationDate on GoalUpdate {\n  id\n  goal {\n    key\n    id\n  }\n  creator {\n    aaid\n    id\n  }\n  lastEditedBy {\n    aaid\n    pii {\n      name\n    }\n    id\n  }\n  creationDate\n  editDate\n}\n\nfragment GoalUpdateDiff on GoalUpdate {\n  ...GoalDateChanged\n  ...GoalStatusChanged\n  ...GoalProgressChanged\n}\n\nfragment GoalUpdateStatus on GoalUpdate {\n  newState {\n    goalStateValue: value\n    ...GoalState\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment GoalUpdateSummary on GoalUpdate {\n  summary\n}\n\nfragment GoalUpdatesTab on Goal {\n  canPostUpdate\n  state {\n    value\n    score\n  }\n  targetDate\n  targetDateConfidence\n  ...GoalUpdateComposer\n  ...UpdatesList\n}\n\nfragment LinkGoalProject on Goal {\n  id\n  projects(tql: \"archived = false\", first: 200) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n}\n\nfragment MetricChart on Goal {\n  ...WrappedWithMetricPopup\n  id\n  progress {\n    type\n    percentage\n  }\n  subGoals {\n    count\n  }\n  metricTargets {\n    edges {\n      node {\n        ...common_metricTarget_direct\n        id\n      }\n    }\n  }\n}\n\nfragment MissedGoalUpdateCard on GoalUpdate {\n  id\n  uuid\n  goal {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...GoalUpdateCardHeader\n  ...GoalUpdateCardTop_PTxnb\n  ...GoalUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment NewGoalUpdate on Goal {\n  id\n  uuid\n  key\n  workspace {\n    uuid\n    id\n    aiConfig {\n      enabled\n    }\n  }\n  phase {\n    name\n  }\n  state {\n    value\n    score\n  }\n  watchers {\n    count\n  }\n  latestUserUpdate {\n    editDate\n    creationDate\n    summary\n    notes {\n      title\n      summary\n      id\n    }\n    id\n  }\n  progress {\n    type\n  }\n  metricTargets {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  ...hasMetric\n  ...GoalProgressEditor\n}\n\nfragment PlatformGoalIcon on Goal {\n  icon {\n    key\n    appearance\n  }\n}\n\nfragment ProjectIcon on Project {\n  private\n  iconUrl {\n    square {\n      light\n      dark\n      transparent\n    }\n  }\n}\n\nfragment ProjectName_data on Project {\n  id\n  key\n  name\n  uuid\n  ...ProjectIcon\n}\n\nfragment ProjectState on ProjectState {\n  label\n  localizedLabel {\n    messageId\n  }\n  projectStateValue: value\n  atCompletionState {\n    value\n    label\n    localizedLabel {\n      messageId\n    }\n  }\n}\n\nfragment ProjectTable on ProjectConnection {\n  edges {\n    node {\n      id\n      newPhase {\n        _id: id\n      }\n      ...ProjectTableRow\n      ...ProjectTableCompactRow\n    }\n  }\n}\n\nfragment ProjectTableCompactRow on Project {\n  id\n  key\n  name\n  state {\n    ...ProjectState\n  }\n  ...ProjectIcon\n}\n\nfragment ProjectTableRow on Project {\n  id\n  owner {\n    id\n    ...UserAvatar_2aqwkz\n  }\n  ...ProjectName_data\n  dueDate {\n    ...TargetDate\n  }\n  state {\n    ...ProjectState\n  }\n}\n\nfragment ShareUpdateButton on Update {\n  __isUpdate: __typename\n  ... on ProjectUpdate {\n    id\n  }\n  ... on GoalUpdate {\n    id\n  }\n  ...ShareUpdateDialogContent\n}\n\nfragment ShareUpdateDialogContent on Update {\n  __isUpdate: __typename\n  ... on ProjectUpdate {\n    id\n    project {\n      key\n      id\n    }\n  }\n  ... on GoalUpdate {\n    id\n    url\n    goal {\n      key\n      id\n    }\n  }\n}\n\nfragment TargetDate on TargetDate {\n  confidence\n  label\n  localizedLabel {\n    messageId\n  }\n  tooltip: label(longFormat: true)\n  localizedTooltip: localizedLabel(longFormat: true) {\n    messageId\n  }\n  overdue\n}\n\nfragment UpdateNote on UpdateNote {\n  archived\n  uuid\n  title\n  summary\n}\n\nfragment UpdatesList on Goal {\n  canEditUpdate\n  updateStreak\n  ...EmptyStateNoUpdates\n  updates(first: 10) {\n    edges {\n      node {\n        uuid\n        creationDate\n        ...EditableGoalUpdateCard\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment UserAvatar on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n  }\n}\n\nfragment UserAvatar_2aqwkz on User {\n  aaid\n  pii {\n    picture\n    accountId\n  }\n}\n\nfragment UserName on User {\n  aaid\n  pii {\n    name\n    accountStatus\n  }\n}\n\nfragment WrappedWithMetricPopup on Goal {\n  id\n  progress {\n    percentage\n  }\n  metricTargets {\n    edges {\n      node {\n        ...common_metricTarget_direct\n        metric {\n          archived\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment common_metricTarget_direct on MetricTarget {\n  startValue\n  targetValue\n  snapshotValue {\n    value\n    id\n  }\n  metric {\n    id\n    name\n    type\n    subType\n  }\n}\n\nfragment hasMetric on Goal {\n  progress {\n    type\n  }\n  metricTargets {\n    edges {\n      node {\n        metric {\n          archived\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment progressBarMetricTarget on Goal {\n  progress {\n    type\n    percentage\n  }\n  metricTargets {\n    edges {\n      node {\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        targetValue\n        metric {\n          type\n          subType\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment progressText on Goal {\n  progress {\n    type\n    percentage\n  }\n  metricTargets {\n    edges {\n      node {\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        targetValue\n        metric {\n          type\n          subType\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment useUserHasCapabilitiesFromGoal on Goal {\n  workspace {\n    currentUserAppCapabilities {\n      capabilities {\n        capability\n        capabilityContainer\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "292611a7bbe7b2f3c254725460a988a4";

export default node;
